'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconChartDiagramChildFocus, iconChartDiagramChildFocusTag } from '@ni/nimble-components/dist/esm/icons/chart-diagram-child-focus';
import { wrap } from '../../utilities/react-wrapper';

export type { IconChartDiagramChildFocus };
export { iconChartDiagramChildFocusTag };
export const NimbleIconChartDiagramChildFocus = wrap(IconChartDiagramChildFocus);